import {EntityModel} from "@fedeltapointofsale/data-client";
import {ShiftData} from "./shift.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ShiftEntityModel extends EntityModel<ShiftData> {

    constructor(injector: Injector) {
        super(injector, ShiftData);
    }
}
